import { useStandardRecordDisciplineListQuery } from '../queries';
import { OptionTuple } from '~/components/Input/Select/Select';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'>;

function StandardRecordDisciplineSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data, isLoading } = useStandardRecordDisciplineListQuery();

  const options = useMemo<OptionTuple[]>(() => {
    return (data ?? []).map(d => [d.description, d.name]);
  }, [data]);

  return (
    <Input.Select
      options={options}
      placeholder={props.placeholder ?? 'Alla discipliner'}
      disabled={isLoading || props.disabled}
      ref={ref}
      {...props}
    />
  );
}

export const StandardRecordDisciplineSelect = forwardRef(StandardRecordDisciplineSelectElement) as <
  TFormState extends BaseFormState,
>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof StandardRecordDisciplineSelectElement>;
